import { render, staticRenderFns } from "./NDraggable.vue?vue&type=template&id=acf296e4"
import script from "./NDraggable.vue?vue&type=script&lang=js"
export * from "./NDraggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports